import { render, staticRenderFns } from "./1952989324777644033.vue?vue&type=template&id=4526156a&scoped=true&"
import script from "./1952989324777644033.vue?vue&type=script&lang=js&"
export * from "./1952989324777644033.vue?vue&type=script&lang=js&"
import style0 from "./1952989324777644033.vue?vue&type=style&index=0&id=4526156a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4526156a",
  null
  
)

export default component.exports